// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3fiX-","infoBtn":"quickbooks_infoBtn__35f9B","formBox":"quickbooks_formBox__3p4rv","formFooter":"quickbooks_formFooter__3u_bE"};